export class DatosDocumentoAttach {
    private idOrganizacionCompra: number;
    private idErp: string[];

    constructor(idOrganizacionCompra: number, idErp: string[]) {
        this.idOrganizacionCompra = idOrganizacionCompra;
        this.idErp = idErp;
    }

    get _idOrganizacionCompra(): number {
        return this.idOrganizacionCompra;
    }

    get _idErp(): string[] {
        return this.idErp;
    }

    set _idOrganizacionCompra(value: number) {
        this.idOrganizacionCompra = value;
    }

    set _idErp(value: string[]) {
        this.idErp = value;
    }
}